import { useSearchParams } from 'react-router-dom'

export function useUrlState<T extends object>(
    defaults: T
): [T, (partial: Partial<T>) => void] {
    const [params, setParams] = useSearchParams()

    const value = {} as T
    for (const key in defaults) {
        const raw = params.get(key)
        if (raw === null) {
            value[key] = defaults[key]
        } else {
            try {
                value[key] = JSON.parse(raw)
            } catch {
                value[key] = raw as T[typeof key]
            }
        }
    }

    const setValue = (partial: Partial<T>) => {
        const merged = { ...value, ...partial }
        const newParams = new URLSearchParams()
        for (const key in defaults) {
            const val = merged[key]
            const def = defaults[key]
            const isDefault = JSON.stringify(val) === JSON.stringify(def)

            if (!isDefault) {
                if (
                    typeof val === 'string' ||
                    typeof val === 'number' ||
                    typeof val === 'boolean'
                ) {
                    newParams.set(key, String(val))
                } else {
                    newParams.set(key, JSON.stringify(val))
                }
            }
        }
        setParams(newParams, { replace: true })
    }

    return [value, setValue]
}
